module.exports = __webpack_public_path__ + "img/btn_select.97afd62c.svg";